import { CART } from "../../ActionType/Cart";

export const setCart = (payload) => {
  return {
    type: CART,
    payload,
  };
};
